module.exports = __webpack_public_path__ + "img/telegram.fe18eea.svg";